'use strict';

var _ = require('lodash');

function MapConfig (config) {

  if (!config) {
    throw new Error('Missing required parameter: config');
  }

  this._config = config;
  this._defaults = config.mapDefaults;
}

MapConfig.prototype = {
  getConfig: function () {
    return this._config;
  },

  getDefaultLocation: function () {
    return this._defaults.center;
  },

  getDefaults: function () {
    return this._defaults;
  },

  setDefaults: function (options) {
    var config = this._config;
    options = options || {};
    this._defaults = _.defaultsDeep(options, this._defaults);

    return this._defaults;
  },

  getEvents: function () {
    var config = this._config;
    return config.events;
  },

  /**
   * Get the configurations for a tile layer. The returned object is ready to be passed into
   * angular-leaflet for rendering.
   *
   * @param  {String} type Tile type
   * @param  {String} id Layer id
   * @param  {Object} options Layer options
   * @return {Object} Tile layer object
   * @return {Object}
   */
  getTileLayer: function (type, id, options) {
    var config = this._config;

    if (!config.tileLayers) {
      throw new Error('No "tileLayers" are defined');
    }

    var tileLayerDefaults = this._defaults.tileLayerOptions;
    var layer = _.clone(config.tileLayers[type], true);

    layer.url = this._buildUrl(layer, id, options);

    layer.name = id || layer.name;
    layer.layerOptions = _.assign({}, tileLayerDefaults, layer.layerOptions, options);

    layer.$show = function (show) {
      show = show !== undefined ? show : true;
      layer.visible = show;
    };

    return layer;
  },

  _buildUrl: function _buildUrl (layer, id, options) {
    if(options && options.resourceProxyUri) {
      var resourceProxyUri = options.resourceProxyUri.replace(/\/$/, '');
      if (layer.name === 'datacapture') {
        return resourceProxyUri + '/' + options.token + '/data_captures/' + options.dataCaptureId + '/' + id + '/{z}/{x}/{y}.png';
      }

      if (layer.name === 'overlay') {
        return resourceProxyUri + '/' + options.token + '/generic/' + id + '/{z}/{x}/{y}.png';
      }
    }

    return layer.url;
  }
};

module.exports = MapConfig;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/config/MapConfig.js